/**
 * Configurações comuns a todos os ambientes: dev e prod
 */
const common = {
    clientId: 'DsMov177',
    clientVersion: '1.0.0',
    clientVersionReleaseDate: '2021-06-15'
};

export default common;